import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Router from '@components/Router/Router';
import { Box, Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { SET_TIMESHEET_LIST } from '@stores/reducers/timesheet-navigation.reducer';
import { getUser } from '@stores/selectors/user.selector';
import { StorageKeys } from 'constants/storage-keys';

import Footer from './Footer';
import Header from './Header';

const useStyles = makeStyles((theme) => ({
  mainContent: {
    flexGrow: 1,
    marginBottom: theme.spacing(2),
  },
}));

const Body = () => {
  const user = useSelector(getUser);
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const isTimesheetPage = location.pathname.startsWith('/timesheets');
    const isReferentialDetailPage =
      location.pathname.startsWith('/referentials/') &&
      location.pathname !== '/referentials/';

    if (!isTimesheetPage && !isReferentialDetailPage) {
      sessionStorage.removeItem(StorageKeys.TIMESHEET_RETURN_URL_KEY);
      dispatch({ type: SET_TIMESHEET_LIST, payload: [] });
    }

    if (!isReferentialDetailPage) {
      sessionStorage.removeItem(StorageKeys.REFERENTIAL_RETURN_TIMESHEET_KEY);
    }
  }, [location.pathname]);

  return (
    <>
      <Header />
      <Container maxWidth="xl" className={classes.mainContent}>
        <Box height="100%" px={{ xs: 0, lg: 4 }}>
          <Router user={user} />
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default withTranslation()(Body);
